// Libs
import React from 'react';
import { Link } from 'react-router-dom';
import { Form, Alert } from 'react-bootstrap';

// Services
import AccountService from 'services/AccountService';

// Components
import Loader from 'components/common/Loader';

// Images
import logoImage from 'images/flip-logo.png';

//-------------------------------------------------------------------------------------------------------------------

class LoginPage extends React.Component {
    
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            error: null,
            email: '',
            password: ''
        };

        this.onSubmit = this.onSubmit.bind(this);
    }

    //--------------------------------------------------------------------------------------------------------------------

    async onSubmit(e) {
        e.preventDefault();
        this.setState({ isLoading: true });

        try {
            // Try to log in
            await AccountService.logIn({
                email: this.state.email,
                password: this.state.password
            });

            // Success
            this.props.onLogIn();
        } catch (error) {
            // Login failed
            this.setState({
                isLoading: false,
                error: error
            });
        }
    }

    //--------------------------------------------------------------------------------------------------------------------

    render() {
        const {
            isLoading,
            error,
            email,
            password
        } = this.state;

        if (isLoading) {
            return (<Loader />);
        }

        return (
            <div className="login-panel">
                <img src={logoImage} />

                <p>Please log in to continue.</p>

                {error &&
                    <Alert color="danger">{error}</Alert>
                }

                <form onSubmit={this.onSubmit}>

                    <Form.Group className="mb-3">
                        <Form.Label className="form-label">Email Address</Form.Label>
                        <input
                            type="text"
                            className="form-control"
                            autoFocus
                            value={email}
                            onChange={e => this.setState({ email: e.target.value })}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label className="form-label">Password</Form.Label>
                        <input
                            type="password"
                            className="form-control"
                            value={password}
                            onChange={e => this.setState({ password: e.target.value })}
                        />
                    </Form.Group>

                    <div className="buttons">

                        <Link to={'/password-reset/_/' + email}>
                            Password reset
                        </Link>

                        <button type="submit" className="btn btn-primary ms-auto">
                            Login
                        </button>

                    </div>

                </form>

            </div>

        );
    }
}

export default LoginPage;